import {GlobalConstants} from "../data/GlobalConstants";
import {handleResponse} from "../util/functions";
import {getToken} from "../helpers/helperJWT";
import {loaderService} from "./loaderService";
import { isObject } from '../util/is';

const url = GlobalConstants.urlApi;

export const clientesService = {
    getAllClients,
    getClientByDocumento,
    getClientById,
    getPuntosVentaByCliente,
    getPuntoVentaById,
    getRutasByPuntoVenta,
    getRutasById,
    setStateClienteById,
    setCrudClientes,
    setCrudPuntoVenta,
    getListOrdenByTypeVisitaEntrega,
    setCrudPuntoVentaItem,
    setStatePuntoVentaById,
    setStateRutaById,
    crudEvidencias,
    getSolicitudesClientes,
    getSolicitudesClientesNew,
    getSolicitudClienteById,
    updateInfoSolicitudClienteById,
    crudEvidenciasSolicitudesCliente,
    VoBoSolicitudesClientes,
    setEstadoClientes,
    getTipoSolicitudClientes,
    getSubCanalByTipologia,
    getClientesCRM,
    setEstadoClientesManual,
    validarExcelCliente,
    getTablaSolicitudes,
    getAgenteComercial,
    getRutas,
    getConsecutivo,
    setSolicitudCliente,
    setObservacionSolicitudCliente,
    getPropietarios,
    getGrupoVenta,
    setSolicitudesClienteAuto,
    getRuteroCliente,
    getReporteSolicitudesPendientes
};

function getTipoSolicitudClientes() {

  const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      },
      body: JSON.stringify()
  };

  return fetch(`${url}/clientes/getTipoSolicitudClientes`, requestOptions)
      .then(handleResponse)
      .then(response => {
          return response;
      });
}

function getAllClients() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/clientes/getAllClients`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getClientById(codigo) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/clientes/getClientById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getClientByDocumento(codigo) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/clientes/getClientByDocumento`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getPuntosVentaByCliente(codigo) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/clientes/getPuntosVentas`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getPuntoVentaById(codigo) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/clientes/getPuntoVentaById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getRutasByPuntoVenta(codigo) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/clientes/getRutasByPuntoVenta`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getRutasById(codigo) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/clientes/getRutasById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setStateClienteById(params) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(params)
    };

    return fetch(`${url}/clientes/setStateClienteById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function setCrudClientes(datos) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({ datos })
    };

    return fetch(`${url}/clientes/crudCliente`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function setCrudPuntoVenta(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({ data })
    };

    return fetch(`${url}/clientes/crudPuntoVenta`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function getListOrdenByTypeVisitaEntrega(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/clientes/getListOrdenByTypeVisitaEntrega`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function setCrudPuntoVentaItem(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({ data })
    };

    return fetch(`${url}/clientes/crudPuntoVentaItem`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function setStatePuntoVentaById(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify( data )
    };

    return fetch(`${url}/clientes/setStatePuntoVentaById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function setStateRutaById(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify( data )
    };

    return fetch(`${url}/clientes/setStateRutaById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function crudEvidencias(files, info) {
  loaderService.showLoader({label: "Cargando..."});

    const formData = new FormData();
    for (const file of files) {
      if(isObject(file?.url)){
        formData.append('IMG', file?.url, file?.url?.name);
      }
    }
    formData.append('data', JSON.stringify(files));
    formData.append('info', JSON.stringify(info));
    formData.append('app', 'maestros');
    formData.append('interface', 'clientes');

    const requestOptions = {
        method: 'POST',
        headers: {
          'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/clientes/crudEvidencias`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}


function getSolicitudesClientes(data) {
  loaderService.showLoader({label: "Cargando..."});

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify( data )
  };

  return fetch(`${url}/clientes/getSolicitudesClientes`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}

function getSolicitudesClientesNew(data) {
  loaderService.showLoader({label: "Cargando..."});

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify(data)
  };

  return fetch(`${url}/clientes/getSolicitudesClientesNew`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}

function getSolicitudClienteById(data) {
  loaderService.showLoader({label: "Cargando..."});

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify( data )
  };

  return fetch(`${url}/clientes/getSolicitudClienteById`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });

}

function updateInfoSolicitudClienteById(data) {
  loaderService.showLoader({label: "Cargando..."});

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify( data )
  };

  return fetch(`${url}/clientes/updateInfoSolicitudClienteById`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });

}

function crudEvidenciasSolicitudesCliente(files, info) {
  loaderService.showLoader({label: "Cargando..."});

  const formData = new FormData();
  for (const file of files) {
    if(isObject(file?.url)){
      formData.append('IMG', file?.url, file?.url?.name);
    }
  }
  formData.append('data', JSON.stringify(files));
  formData.append('info', JSON.stringify(info));
  formData.append('app', 'maestros');
  formData.append('interface', 'SolicitudesClientes');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Authorization': getToken()
    },
    body: formData
  };

  return fetch(`${url}/clientes/crudEvidenciasSolicitudesCliente`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });

}

function VoBoSolicitudesClientes(data) {
  loaderService.showLoader({label: "Cargando..."});

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify( {arr: data} )
  };

  return fetch(`${url}/clientes/VoBoSolicitudesClientes`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });

}

//Denegar Solicitudes
function setEstadoClientes(data, estado, idUsuario){
  loaderService.showLoader({label: "Cargando..."})

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify( {identificadores: data, estado: estado, idUsuario: idUsuario} )
  };

  return fetch(`${url}/clientes/setEstadoClientes`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}

function getSubCanalByTipologia(tipologia){
  loaderService.showLoader({label: "Cargando..."})

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify( {tipologia} )
  };

  return fetch(`${url}/clientes/getSubCanalByTipologia`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}

function getClientesCRM(identificadores, usuario){
  loaderService.showLoader({label: "Cargando..."})

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify( {identificadores: identificadores, usuario: usuario} )
  };

  return fetch(`${url}/clientes/getClientesCRM`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}

function setEstadoClientesManual(identificadores, estado, usuario){
  loaderService.showLoader({label: "Cargando..."})

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify( {identificadores: identificadores, estado: estado, idUsuario: usuario} )
  };

  return fetch(`${url}/clientes/setEstadoClientesManual`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}

//CARGUE MASIVO CLIENTES
function validarExcelCliente(data){
  loaderService.showLoader({label: "Cargando..."})

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify(data)
  };

  return fetch(`${url}/clientes/validarExcelCliente`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}

//TABLA DE SOLICITUD
function getTablaSolicitudes(data){
  loaderService.showLoader({label: 'Cargando...'})

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify(data)
  }

  return fetch(`${url}/clientes/getTablaSolicitudes`, requestOptions)
    .then(handleResponse)
    .then( response => {
      return response;
    })
}

function getAgenteComercial(data){

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify(data)
  }

  return fetch(`${url}/clientes/getAgenteComercial`, requestOptions)
    .then(handleResponse)
    .then( response => {
      return response;
    })
}

// GET DOWNLOAD RUTAS
function getRutas(codigo){
  loaderService.showLoader({label: "Cargando..."})

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify({codigo})
  };

  return fetch(`${url}/clientes/getRutas`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}

function getConsecutivo(data){

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify(data)
  }

  return fetch(`${url}/clientes/getConsecutivo`, requestOptions)
    .then(handleResponse)
    .then( response => {
      return response;
    })
}

//Guardar data excel
async function setSolicitudCliente(data){
  loaderService.showLoader({label: "Cargando..."});

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify(data)
  };

  return fetch(`${url}/clientes/setSolicitudCliente`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
  });
}

//setObservacionSolicitudCliente
function setObservacionSolicitudCliente(data){

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify(data)
  }

  return fetch(`${url}/clientes/setObservacionSolicitudCliente`, requestOptions)
    .then(handleResponse)
    .then( response => {
      return response;
    })
}

function getPropietarios(){

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify()
  }

  return fetch(`${url}/clientes/getPropietarios`, requestOptions)
    .then(handleResponse)
    .then( response => {
      return response;
    })
}

function getGrupoVenta(){

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify()
  }

  return fetch(`${url}/clientes/getGrupoVenta`, requestOptions)
    .then(handleResponse)
    .then( response => {
      return response;
    })
}

function setSolicitudesClienteAuto(data){

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify(data)
  }

  return fetch(`${url}/clientes/setSolicitudesClienteAuto`, requestOptions)
    .then(handleResponse)
    .then( response => {
      return response;
    })
}

function getRuteroCliente(){
  loaderService.showLoader({label: "Cargando..."})

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: ''
  }

  return fetch(`${url}/clientes/getRuteroCliente`, requestOptions)
    .then(handleResponse)
    .then( response => {
      return response;
    })
}

function getReporteSolicitudesPendientes(data){
  loaderService.showLoader({label: "Cargando..."})

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify(data)
  }

  return fetch(`${url}/clientes/getReporteSolicitudesPendientes`, requestOptions)
    .then(handleResponse)
    .then( response => {
      return response;
    })
}
